import { toggleFilterSelection, removeFilterGroup } from './utils';

export default function studentScope(
  state = {
    hasFetchedFilters: false,

    filters: {},
    selected: {},
    applied: false,

    manuallyCreatedCaseloads: [],
    loadingManuallyCreated: false,

    activeModule: null,
    instances: {},

    searching: false,
    searchInput: {},
    search: {},
  },
  action,
) {
  switch (action.type) {
    case 'SCOPE_FILTER.POPULATE_FILTERS':
      return {
        ...state,
        hasFetchedFilters: true,
        filters: action.filters,
      };
    case 'SCOPE_FILTER.SET_SCOPE_FILTER_OPEN':
      return {
        ...state,
        activeModule: action.module,
        instances: {
          ...state.instances,
          [action.module]: action.open,
        },
      };
    case 'SCOPE_FILTER.SET_ACTIVE_MODULE':
      return {
        ...state,
        activeModule: action.module,
      };
    case 'SET_NEW_CASELOAD_NAME':
      return {
        ...state,
        manuallyCreatedCaseloads: state.manuallyCreatedCaseloads.map(c =>
          c.id === action.caseloadId ? { ...c, title: action.name } : c,
        ),
      };
    case 'REMOVE_DELETED_CASELOAD':
      return {
        ...state,
        manuallyCreatedCaseloads: state.manuallyCreatedCaseloads.filter(
          c => c.id !== action.caseloadId,
        ),
      };
    case 'SCOPE_FILTER.TOGGLE_FILTER': {
      const selected = toggleFilterSelection({
        filterData: action,
        selectedState: state.selected,
      });
      return {
        ...state,
        applied: false,
        selected,
      };
    }
    case 'SCOPE_FILTER.REMOVE_FILTER': {
      return {
        ...state,
        selected: removeFilterGroup({
          selectedState: state.selected,
          filterGroup: action.group,
        }),
      };
    }
    case 'SCOPE_FILTER.ADD_MULTIPLE_VALUES_FOR_ONE_FILTER': {
      const { group, source } = action?.valueList?.[0] ?? {};

      if (!group) {
        return state;
      }
      const dataToUpdate = action.valueList.reduce(
        (acc, entry) => ({
          ...acc,
          [entry.id]: {
            group,
            source,
            ...entry,
            id: entry.id,
            label: entry.label,
          },
        }),
        {},
      );

      const updatedFilterWithValueList = {
        ...state.selected[group],
        ...dataToUpdate,
      };
      localStorage.setItem(
        'selectedStudentScopeFilter',
        JSON.stringify(updatedFilterWithValueList),
      );

      return {
        ...state,
        applied: false,
        selected: {
          ...state.selected,
          [group]: updatedFilterWithValueList,
        },
      };
    }
    case 'SCOPE_FILTER.APPLY_FILTERS':
      return {
        ...state,
        applied: true,
      };
    case 'SCOPE_FILTER.SET_SEARCH_TERM':
      return {
        ...state,
        searching: false,
        search: {
          ...state.search,
          [action.filter]: action.searchTerm,
        },
      };
    case 'SCOPE_FILTER.SET_INPUT_VALUE':
      return {
        ...state,
        searching: true,
        searchInput: {
          ...state.searchInput,
          [action.filter]: action.searchTerm,
        },
      };
    case 'SCOPE_FILTER.RESET_FILTERS':
      localStorage.removeItem('selectedStudentScopeFilter');
      return {
        ...state,
        selected: {},
      };
    case 'SCOPE_FILTER.POPULATE_MANUALLY_CREATED_CASELOADS':
      return {
        ...state,
        manuallyCreatedCaseloads: action.caseloads,
      };
    case 'SCOPE_FILTER.SET_MANUALLY_CREATED_CASELOADS_LOADING':
      return {
        ...state,
        loadingManuallyCreated: action.loading,
      };
    case 'SCOPE_FILTER.CLEAR_FILTERS':
      return {
        ...state,
        hasFetchedFilters: false,
        filters: {},
      };
    case 'SCOPE_FILTER.RESTORE_FILTERS':
      return {
        ...state,
        selected: action.selected,
      };
    case 'SCOPE_FILTER.POPULATE_HAS_FETCHED_FILTERS':
      return {
        ...state,
        hasFetchedFilters: action.hasFetchedFilters,
      };
    default:
      return state;
  }
}
